<template>
    <div class="row main-content">
        <div class="col-md-2 ">
            <sidebar>Account Details</sidebar>
        </div>
        <div class="col-md-10">
            <div class="col-sm-12 col-md-6" v-if="user">
                <success v-if="success" class="mb-2">Your data has been updated.</success>
                <form class="mb-5">
                    <div class="form-group">
                        <label for="name">First Name:</label>
                        <input type="text" name="f_name" class="form-control" v-model="user.f_name" :class="[{'is-invalid':errorFor('f_name')}]">
                        <v-errors :errors="errorFor('f_name')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="name">Last Name:</label>
                        <input type="text" name="l_name" class="form-control" v-model="user.l_name" :class="[{'is-invalid':errorFor('l_name')}]">
                        <v-errors :errors="errorFor('l_name')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="company">Company:</label>
                        <input type="text" name="company" class="form-control" v-model="user.company" :class="[{'is-invalid':errorFor('company')}]">
                        <v-errors :errors="errorFor('company')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="title">Title:</label>
                        <input type="text" name="title" class="form-control" v-model="user.title" :class="[{'is-invalid':errorFor('title')}]">
                        <v-errors :errors="errorFor('title')"></v-errors>
                    </div>

                    <div class="form-group">
                        <label for="address">Address:</label>
                        <input type="text" name="add1" class="form-control" v-model="user.add1" :class="[{'is-invalid':errorFor('add1')}]">
                        <v-errors :errors="errorFor('add1')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="address2">Address Line 2:</label>
                        <input type="text" name="add2" class="form-control" v-model="user.add2" :class="[{'is-invalid':errorFor('add2')}]">
                        <v-errors :errors="errorFor('add2')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="city">City:</label>
                        <input type="text" name="city" class="form-control" v-model="user.city" :class="[{'is-invalid':errorFor('city')}]">
                        <v-errors :errors="errorFor('city')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="state">State:</label>
                        <input type="text" name="state" class="form-control" v-model="user.state" :class="[{'is-invalid':errorFor('state')}]">
                        <v-errors :errors="errorFor('state')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="zipcode">Zipcode:</label>
                        <input type="text" name="zip" class="form-control" v-model="user.zip" :class="[{'is-invalid':errorFor('zip')}]">
                        <v-errors :errors="errorFor('zip')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="email">Email Address:</label>
                        <input type="email" name="email" class="form-control" v-model="user.email"  disabled>
                        <small class="form-text text-muted">Email is not editable.</small>
                    </div>
                    <div class="form-group">
                        <label for="phone">Phone Number:</label>
                        <input type="text" name="phone" class="form-control" v-model="user.phone" :class="[{'is-invalid':errorFor('phone')}]">
                        <v-errors :errors="errorFor('phone')"></v-errors>
                    </div>
                    <div class="d-flex justify-content-between">
                        <router-link class="btn-round-red pt9rem"
                        :to="{ name: 'changePassword' }"
                        >Change Password</router-link
                        >
                        <button
                            class="btn-round-green pt9rem"
                            :disabled="loading"
                            @click.prevent="updateUser"
                        >
                            SAVE
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
label {
    margin-bottom: 0;
    font-weight: 600;
}
</style>
<script>
import { mapState, mapGetters } from "vuex";
import validationErrors from "../mixins/validationErrors";

export default {
    mixins: [validationErrors],
    data() {
        return {
            loading: false,
            route: null,
            success:false
        };
    },

    computed: {
        ...mapState({ user: state => state.user }),
    },
    methods: {
        async updateUser() {
            this.loading = true;
            this.errors = null;
            try {
                await axios.post(`/api/userUpdate`, this.user).then(response => {
                    window.scrollTo(0,0);
                    this.loading = false;
                    this.success=true;
                    var self=this;
                    setTimeout(function(){
                        self.success=false;
                    }, 4000);
                });
            } catch (error) {
                this.errors = error.response && error.response.data.errors;
            }

        }
        // async reloadUser(){
        //     this.loading=true;
        //     this.errors=null;

        //     try {
        //         const response=await axios.get(`/api/user/${this.user.id}/`);
        //         if(200==response.status){
        //             this.$store.dispatch("loadUser");
        //         }
        //     } catch (error) {
        //          this.errors=error.response && error.response.data.errors;
        //     }
        //     this.loading=false;
        // }
    }
};
</script>
